import script from "./GeneralWidgetWrapper.vue?vue&type=script&lang=ts&setup=true"
export * from "./GeneralWidgetWrapper.vue?vue&type=script&lang=ts&setup=true"

import "./GeneralWidgetWrapper.vue?vue&type=style&index=0&id=478d87b8&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-478d87b8"]])

export default __exports__